import styled from "styled-components";

export const BackButton = styled.button`
  width: 350px;
  border: none;
  color: #fff;
  background: #1c77c6;
  margin-top: 1rem;
  padding: 0.85rem 0.45rem;
  transition: background 0.2s ease-in;
  font-size: 1.25rem;
`;
